<div class="page-header">
  <app-prev-next-button (click)="toScreening()" [direction]="'left'" [label]="'triagem'"></app-prev-next-button>
  <h1>Conferência</h1>
  <app-prev-next-button (click)="toStocking()" [direction]="'right'" [label]="'armazenagem'"></app-prev-next-button>
</div>
